export interface DeviceSelection {
  id: string | null;
  name: string | null;
  pointId: string | null;
  pointName: string | null;
  pointValue: { value: number | boolean; time?: string } | null;
}

export interface VariableUiState {
  deviceName?: string;
  pointName?: string;
  pointValue?: { value: number | boolean; time?: string } | null;
}

export interface CustomFormulaState {
  expression: string;
  variables: string[];
  valid: boolean;
  validated: boolean;
  validationError: string | null;
}

export const EMPTY_CUSTOM_FORMULA: CustomFormulaState = {
  expression: '',
  variables: [],
  valid: false,
  validated: false,
  validationError: null,
};
